module.exports = __webpack_public_path__ + "mz.svg?c8308283028cbd9a0281a61635ed3b20";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/mz.svg
// module id = 1526
// module chunks = 0